/**
 * Submission metrics calculations for company card.
 *
 * Precondition: submissions array with reportDate or filingDate fields
 * Postcondition: Returns metrics object with derived values
 * Invariant: Input array is not mutated
 */

import { getQuarter, type Submission } from './parsers.js';

export interface SubmissionMetricsResult {
  yearsCount: number;
  firstYear: string | null;
  latestQuarter: string | null;
  latestQuarterLabel: string | null;
}

export function augmentSubmissions(submissions: Submission[]): SubmissionMetricsResult {
  const metrics: SubmissionMetricsResult = {
    yearsCount: 0,
    firstYear: null,
    latestQuarter: null,
    latestQuarterLabel: null,
  };

  if (!submissions || !submissions.length) return metrics;

  // Extract unique years from submissions
  const yearSet: Record<string, boolean> = {};
  submissions.forEach((s) => {
    const date = s.reportDate || s.filingDate;
    if (!date) return;
    const quarter = getQuarter(date);
    const year = quarter.split('-')[0];
    yearSet[year] = true;
  });

  const years = Object.keys(yearSet).sort();

  if (!years.length) return metrics;

  metrics.yearsCount = years.length;
  metrics.firstYear = years[0];

  // Get latest quarter from first submission (assumed sorted desc)
  const latestDate = submissions[0].reportDate || submissions[0].filingDate;
  if (latestDate) {
    const latest = getQuarter(latestDate);
    const parts = latest.split('-');
    const year = parts[0];
    const q = parts[1];
    metrics.latestQuarter = latest;
    metrics.latestQuarterLabel = `${q} ${year}`;
  }

  return metrics;
}
